<template>
  <div id="contenedor-add-evento-agenda">
    <v-form v-model="formularioValido" ref="registrarNuevoEvento">
      <v-card>
        <v-card-title class="secondary--text">
          Editar evento
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mx-2"></v-divider>
        <v-card-text>
          <v-row>
            <custom-text-field
              cols="12"
              v-model="evento.nombre"
              label="Nombre del evento"
              :rules="[mixReglas.requerido]">
            </custom-text-field>
            <v-col cols="12">
              <CustomTextArea
                v-model="evento.asunto"
                label="Asunto del evento"
                placeholder="Ingrese el asunto del evento"
                rows="2"
                :rules="[mixReglas.requerido]">
              </CustomTextArea>
            </v-col>
            <custom-date-picker
              cols="6"
              v-model="evento.fecha"
              label="Fecha del evento"
              :rules="[mixReglas.requerido]">
            </custom-date-picker>
            <CustomSelect
              v-model="evento.hora"
              cols="6"
              label="Hora del evento"
              :items="getHorasList"
              :rules="[mixReglas.requerido]">
            </CustomSelect>
            <v-col cols="12">
              <CustomTextArea
                v-model="evento.lugar"
                label="Lugar del evento (opcional)"
                placeholder="Ingrese el lugar del evento"
                rows="2">
              </CustomTextArea>
            </v-col>
            <v-col cols="12">
              <h3>Invitar a:</h3>
              <Directorio v-model="evento.invitados" :id-contrato="idContrato">
              </Directorio>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <custom-button
              @click="cerrar"
              tipo="formCancelar"
              label="Cancelar"
              class="mr-3">
            </custom-button>
            <custom-button
              @click="guardarEvento"
              :disabled="!formularioValido || enviandoFormulario"
              :loading="enviandoFormulario"
              tipo="formAceptar"
              label="Guardar">
            </custom-button>
          </v-card-actions>
      </v-card>
    </v-form>
  </div>
  </template>

<script>
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomTextArea from '@/components/inputs/sinColumnas/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';
import Directorio from '@/components/administracion/contratos/contrato/directorios/Directorio.vue';
import mixSendEmail from '@/helpers/mixSendEmail';
import mixAgendaContrato from './mixAgendaContrato';

export default {
  name: 'edit-evento',
  mixins: [mixAgendaContrato, mixSendEmail],
  props: {
    idContrato: {
      type: String,
      required: true,
    },
    numeroContrato: {
      type: String,
      required: false,
    },
    editEvento: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomTextField,
    CustomSelect,
    CustomDatePicker,
    CustomTextArea,
    CustomButton,
    Directorio,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      evento: {
        nombre: this.editEvento.nombre,
        asunto: this.editEvento.asunto,
        fecha: this.editEvento.fecha,
        hora: this.editEvento.hora,
        lugar: this.editEvento.lugar,
        invitados: this.editEvento.invitados || [],
      },
    };
  },
  methods: {
    async guardarEvento() {
      if (this.evento.invitados.length > 0) {
        await this.mixSendEmail({
          to: this.evento.invitados,
          subject: `⚠️ Actualización: Invitación a evento: ${this.evento.nombre} - ${this.numeroContrato}`,
          text: `Estimados, el evento es para ${this.evento.asunto} el ${this.evento.fecha} a las ${this.evento.hora}. En ${this.evento.lugar}.`,
        });
      }
      await this.mixActualizarAgenda();
    },
    limpiarFormulario() {
      this.$refs.registrarNuevoEvento.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
  computed: {
    getHorasList() {
      const horas = [];
      const horaInicio = 7;
      const horaFin = 19;
      for (let hora = horaInicio; hora <= horaFin; hora += 1) {
        horas.push(`${hora.toString().padStart(2, '0')}:00`);
        if (hora !== horaFin) {
          horas.push(`${hora.toString().padStart(2, '0')}:30`);
        }
      }
      return horas;
    },
  },
};
</script>

  <style lang="scss">

  </style>
